export enum InteractionMode {
    DEFAULT = 0,
    POI_NAVIGATION = 1
}
